module.exports = __webpack_public_path__ + "static/img/10.926e7e79.jpg";